import { useMemo } from 'react'
import * as CONST from 'ui/constants/index'

type Props = {
  className?: string
  platform: string
  message: string
  subject: string
}

export const MShareIcon = ({
  className,
  platform,
  message,
  subject,
}: Props) => {
  const computedUrl = useMemo(() => {
    let url = ''
    if (platform === CONST.PLATFORM.FACEBOOK) {
      url = `https://www.facebook.com/sharer.php?u=${window.location.origin}/`
    } else if (platform === CONST.PLATFORM.TWITTER) {
      url = `https://twitter.com/intent/tweet?url=${window.location.origin}&text=${message}`
    } else if (platform === CONST.PLATFORM.EMAIL) {
      url = `mailto:?subject=${subject}&body=${message}`
    }

    return url
  }, [platform, message, subject])

  return (
    <a
      href={computedUrl}
      className={className}
      aria-label={`Share: ${platform}`}
      rel="noreferrer"
      target="_blank"
    >
      {platform === CONST.PLATFORM.FACEBOOK && (
        <svg
          className="facebook"
          width="26"
          height="26"
          viewBox="0 0 26 26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="M13.9 25.8H1.6c-.8 0-1.4-.6-1.4-1.4V1.6A1.4 1.4 0 011.6.2h22.8a1.4 1.4 0 011.4 1.4v22.8c0 .8-.6 1.4-1.4 1.4h-6.5v-10h3.3l.5-3.8h-3.8V9.6c0-1.2.3-2 1.9-2h2V4.3l-3-.1c-3 0-5 1.8-5 5v3h-3.3v3.8H14v9.9z"
              fill="currentColor"
            />
          </g>
        </svg>
      )}
      {platform === CONST.PLATFORM.INSTAGRAM && (
        <svg
          className="instagram"
          width="26"
          height="26"
          viewBox="0 0 26 26"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="M13 .2c3.48 0 3.91.01 5.28.08a9.4 9.4 0 013.1.6c.85.32 1.56.76 2.27 1.47a6.28 6.28 0 011.48 2.27c.31.81.53 1.74.6 3.1.06 1.37.07 1.8.07 5.28 0 3.48-.01 3.91-.08 5.28a9.4 9.4 0 01-.6 3.1 6.27 6.27 0 01-1.47 2.27 6.28 6.28 0 01-2.27 1.48c-.81.31-1.74.53-3.1.6-1.37.06-1.8.07-5.28.07a91.3 91.3 0 01-5.28-.08 9.4 9.4 0 01-3.1-.6 6.27 6.27 0 01-2.27-1.47 6.27 6.27 0 01-1.48-2.27 9.4 9.4 0 01-.6-3.1A91.3 91.3 0 01.2 13c0-3.48.01-3.91.08-5.28a9.4 9.4 0 01.6-3.1c.32-.85.76-1.56 1.47-2.27A6.27 6.27 0 014.62.87a9.4 9.4 0 013.1-.6A91.3 91.3 0 0113 .2zm0 2.3c-3.42 0-3.82.02-5.17.08a7.08 7.08 0 00-2.38.44c-.6.23-1.02.51-1.47.96-.45.45-.73.87-.96 1.47a7.06 7.06 0 00-.44 2.38A89.05 89.05 0 002.51 13c0 3.42 0 3.82.07 5.17.06 1.25.27 1.93.44 2.38.23.6.51 1.02.96 1.47.45.45.87.73 1.47.96.45.17 1.13.38 2.38.44 1.35.06 1.75.07 5.17.07s3.82 0 5.17-.07a7.08 7.08 0 002.38-.44c.6-.23 1.02-.51 1.47-.96.45-.45.73-.87.96-1.47.17-.45.38-1.13.44-2.38.06-1.35.07-1.75.07-5.17s0-3.82-.07-5.17a7.08 7.08 0 00-.44-2.38c-.23-.6-.51-1.02-.96-1.47a3.97 3.97 0 00-1.47-.96 7.06 7.06 0 00-2.38-.44A89.05 89.05 0 0013 2.51zm0 3.93a6.57 6.57 0 110 13.14 6.57 6.57 0 010-13.14zm0 10.84a4.27 4.27 0 100-8.54 4.27 4.27 0 000 8.54zm8.37-11.1a1.54 1.54 0 11-3.07 0 1.54 1.54 0 013.07 0z"
              fill="currentColor"
            />
          </g>
        </svg>
      )}
      {platform === CONST.PLATFORM.TWITTER && (
        <svg
          className="twitter"
          width="26"
          height="23"
          viewBox="0 0 26 23"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="M25.8 3.36c-.96.44-1.97.73-3.02.86A5.43 5.43 0 0025.1 1.2a10.27 10.27 0 01-3.33 1.32A5.15 5.15 0 0017.92.8a5.35 5.35 0 00-5.25 5.45c0 .43.05.85.14 1.24A14.73 14.73 0 011.98 1.8a5.6 5.6 0 001.63 7.29 5.1 5.1 0 01-2.38-.68v.06a5.4 5.4 0 004.21 5.35 4.95 4.95 0 01-2.37.1 5.28 5.28 0 004.9 3.78A10.3 10.3 0 01.2 19.95a14.5 14.5 0 008.05 2.45c9.66 0 14.94-8.3 14.94-15.51v-.71a10.86 10.86 0 002.61-2.82"
              fill="currentColor"
            />
          </g>
        </svg>
      )}
      {platform === CONST.PLATFORM.EMAIL && (
        <svg
          className="email"
          width="24"
          height="22"
          viewBox="0 0 16 14"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 0H1C.4 0 0 .4 0 1v1.4l8 4.5 8-4.4V1c0-.6-.4-1-1-1z"
            fill="#909495"
          />
          <path
            d="M7.5 8.9L0 4.7V13c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V4.7L8.5 8.9c-.28.14-.72.14-1 0z"
            fill="#909495"
          />
        </svg>
      )}
      {platform === CONST.PLATFORM.YOUTUBE && (
        <svg
          className="youtube"
          width="24"
          height="18"
          viewBox="0 0 24 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.52 12.13V5.34l6.49 3.41-6.49 3.38zm14.24-7.96s-.24-1.67-.95-2.4C21.89.8 20.87.8 20.4.74 17.03.5 12 .5 12 .5h-.02S6.96.5 3.6.74C3.14.8 2.12.81 1.2 1.77c-.72.73-.95 2.4-.95 2.4S0 6.12 0 8.07v1.84c0 1.96.24 3.91.24 3.91s.23 1.67.95 2.4c.92.97 2.12.94 2.65 1.04 1.92.18 8.16.24 8.16.24s5.04 0 8.4-.25c.47-.06 1.5-.06 2.4-1.03.73-.73.96-2.4.96-2.4s.24-1.95.24-3.9V8.07c0-1.96-.24-3.91-.24-3.91z"
            fill="currentColor"
          />
        </svg>
      )}
      {platform === CONST.PLATFORM.VIMEO && (
        <svg
          className="vimeo"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.99 6.74c-.1 2.31-1.74 5.47-4.9 9.48-3.25 4.19-6.02 6.28-8.28 6.28-1.4 0-2.58-1.27-3.55-3.83l-1.93-7.03C4.6 9.08 3.83 7.81 3 7.81c-.18 0-.8.37-1.88 1.12L0 7.49A322.2 322.2 0 003.5 4.4c1.57-1.35 2.76-2.06 3.55-2.13 1.86-.18 3 1.08 3.44 3.78.46 2.91.79 4.72.97 5.43.54 2.41 1.13 3.62 1.77 3.62.5 0 1.26-.78 2.26-2.34 1-1.56 1.54-2.75 1.61-3.57.15-1.35-.39-2.02-1.6-2.02-.58 0-1.18.12-1.78.37C14.9 3.74 17.16 1.9 20.5 2c2.47.07 3.63 1.65 3.49 4.74"
            fill="currentColor"
          />
        </svg>
      )}
    </a>
  )
}
